/**
 * Operations / Dispatch — the PDQ Dispatch + Field App.
 *
 * (Lived at /dashboards/schedule/dispatch while Operations was dissolved; the
 * Schedule section is Operations again and its old URLs redirect here.)
 *
 * Ported from the standalone prototype (field-app/field-app.html) into React.
 * Office side = the dispatch board (inbound queue, rep status, dispatch log);
 * Field side = the phone-shaped rep app (3-step close → work auth → signed).
 * Flip between them with the Field ⇄ Office toggle (role-default).
 *
 * LIVE data: Active Jobs / Signed Today (from v_jobs_full via DispatchFieldApp).
 * MOCK (later Phase-3 / Encircle-replacement waves): inbound call queue, AI
 * scoring + transcripts, GPS rep status, SMS dispatch sender, work-auth +
 * signature + objection flow. See src/components/field/data.ts.
 */
import { createFileRoute } from '@tanstack/react-router';
import { DispatchFieldApp } from '~/components/field/DispatchFieldApp';
import { DashboardShell } from '~/components/dashboard/DashboardShell';
import { DASHBOARDS } from '~/lib/dashboards';
import { useRouteAnalytics } from '~/lib/analytics';

export const Route = createFileRoute('/_app/dashboards/operations/dispatch')({
  component: DispatchPage,
});

function DispatchPage() {
  // Specific tab routes bypass the catch-all dispatcher, so they have to
  // instrument analytics themselves to show up in Dashboard Utilization.
  useRouteAnalytics('operations', 'dispatch');
  // Wrap in the shell so the Operations tab strip stays visible (you can leave
  // Dispatch for the other Operations tabs without using the side menu).
  return (
    <DashboardShell dashboard={DASHBOARDS.operations}>
      <DispatchFieldApp />
    </DashboardShell>
  );
}
